import type { FaireProductEntity } from "../../entity_types/product";

export const p_5lr5ynx4gy: FaireProductEntity = {
  token: "p_5lr5ynx4gy",
  type: "product",
  name: "Tantric Rose Blossom Cacao - Organic Ceremonial Chocolate",
  brandToken: "b_djuc44eyt2",
  brandName: "Ora Cacao",
  imageUrl:
    "https://cdn.faire.com/fastly/4245e68e657c0c128244ebcf3078235373301fb569e7070a6c0d0692e2c160b4.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e779a2fc4313e177f7204941a921cd0fbb9572f4dc86ae4e52d4ea0ca5e845ea.png",
    "https://cdn.faire.com/fastly/1f747abb235ee5e0715737b342f0dbf39252528a60e39453e42c7a02edc40e90.png",
    "https://cdn.faire.com/fastly/b0a743d43f62d10fe7d570952ce4077bef71234c68cdf86a96586e26ef2092a1.jpeg",
    "https://cdn.faire.com/fastly/064b94bd5eebe080422e6cf3161eab913ac1ddb843f17e65b665820a859e8621.png",
    "https://cdn.faire.com/fastly/96b080780feeaf919022b6e5c12c2dc27e836536ed0648c5194a771dd58ae352.png",
    "https://cdn.faire.com/fastly/ff14632cc74547b0f946b10f447087969fb55da28f00650d7009f1d1a3396f05.jpeg",
    "https://cdn.faire.com/fastly/5c38f475e5ff887533c563dfb1cf99bc530c90d2e9b7bfa8be37cae212a57714.jpeg",
    "https://cdn.faire.com/fastly/eca73e8c2a4f269af54a59c614db2f7889438af55f7caacbb4db7174fd53afb1.jpeg",
    "https://cdn.faire.com/fastly/ba9f0afbfb6c54ebebb5145b45981a33a56114effebb53c0eeac249451734017.jpeg",
    "https://cdn.faire.com/fastly/4a644d91e35bce9d97db6c0891f1eb5affbb1ecc9d7e57727fbef4d7dfebae59.jpeg",
  ],
  priceDollars: 19.8,
  description:
    "Take yourself on a tantric date, slowing down to savor the full experience of this sensual cacao. Find healing nourishment and support for your own heart blossoming with a full yes to your life. Whole rose petals act in high frequency synergy with our pure ceremonial cacao to connect you to the sublime joy of the present moment. This cacao comes from 700 small family farms in the Kilombero Valley, a biodiversity hotspot.\n\nDamiana is an aphrodisiac & known to boost sexual potency. The shrubs can be found on dry, rocky hillsides in Texas, California, Mexico, and Central America. Licorice root is a powerful antiviral, anti-inflammatory & immuno-modulating herb commonly found in herbal medicine cabinets around the world.\n\nOrganic Ingredients: Cacao Beans from Tanzania, Pink Rose Petals from Morocco, Orange Peel from US, Damiana from Mexico, Licorice Root from Turkey.\n\nMakes a great coffee replacement!\nFor dark chocolate lovers.\nLab tested for heavy metals safety.\nHigh flavanol / flavonoid.",
  tags: [],
  msrpDollars: 33,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-30T01:35:40.670Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
